import LabeledInput from 'components/fields/LabeledInput';
import LeadrsLogo from 'components/icons/LeadrsLogo';
import Default from 'layouts/auth/types/Default';
import { useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { GoogleLogin } from '@react-oauth/google';

function SignInDefault() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const storeSession = (data: any) => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user-type', data.type);
        localStorage.setItem('user-email', data.email);
        if (data.canSwitchAccountType) {
            localStorage.setItem('can-switch-account-type', 'true');
        } else {
            localStorage.removeItem('can-switch-account-type');
        }
        if (data.linkedToken) {
            localStorage.setItem('linked-token', data.linkedToken);
            localStorage.setItem('linked-user-type', data.linkedUserType);
            localStorage.setItem('linked-user-email', data.linkedUserEmail);
        } else {
            localStorage.removeItem('linked-token');
            localStorage.removeItem('linked-user-type');
            localStorage.removeItem('linked-user-email');
        }
    };

    const loginGoogle = (token: string) => {
        axios
            .post(`${CONFIG.apiUrl}/auth/google`, { token })
            .then((response: any) => {
                if (response.data.token) {
                    storeSession(response.data);
                    window.location.href = '/dashboard';
                }
            })
            .catch(() => {});
    };

    const login = () => {
        axios
            .post(
                `${CONFIG.apiUrl}/auth/login`,
                JSON.stringify({ email, password }),
                { headers: { 'Content-Type': 'application/json' } }
            )
            .then((res) => {
                storeSession(res.data);
                window.location.href = '/dashboard';
            })
            .catch((err) => {
                setError(err.response.data.error);
            });
    };

    return (
        <Default
            maincard={
                <div className="flex min-h-full w-full items-center justify-center px-6 py-12 lg:items-start lg:justify-start lg:px-12 lg:pt-[8vh]">
                    <div className="w-full max-w-[400px] flex-col">
                        {/* Heading */}
                        <h1 className="mt-10 font-crimson text-[42px] leading-[1.1] text-leadrs-text">
                            Se connecter
                        </h1>
                        <p className="mt-3 font-geist text-base text-leadrs-text-soft">
                            Bon retour sur Leadrs.
                        </p>

                        {/* Error */}
                        {error && (
                            <div className="mt-4 rounded-lg bg-leadrs-red-soft px-4 py-3">
                                <p className="font-geist text-sm text-leadrs-red-focus">
                                    {error}
                                </p>
                            </div>
                        )}

                        {/* Fields */}
                        <div className="mt-6 space-y-3">
                            <LabeledInput
                                id="email"
                                label="Adresse mail"
                                placeholder="hello@entreprise.fr"
                                type="email"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <LabeledInput
                                id="password"
                                label="Mot de passe"
                                placeholder="········"
                                type="password"
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        {/* Forgot password */}
                        <div className="mt-3 flex justify-end">
                            <a
                                href="/auth/forgot-password/default"
                                className="font-geist text-xs text-leadrs-text-soft hover:text-leadrs-yellow-focus"
                            >
                                Mot de passe oublié ?
                            </a>
                        </div>

                        {/* Submit */}
                        <button
                            className="mt-5 w-full rounded-xl bg-leadrs-yellow-focus py-3 font-geist text-base font-medium text-white transition-colors hover:bg-leadrs-yellow-focus/80"
                            onClick={login}
                        >
                            Je me connecte
                        </button>

                        {/* Divider */}
                        <div className="mt-5 flex items-center gap-3">
                            <div className="h-px w-full bg-leadrs-stroke" />
                            <span className="font-geist text-xs text-leadrs-text-soft">
                                OU
                            </span>
                            <div className="h-px w-full bg-leadrs-stroke" />
                        </div>

                        {/* Google */}
                        <div className="mt-4 flex w-full">
                            <GoogleLogin
                                onSuccess={(credentialResponse: any) => {
                                    loginGoogle(credentialResponse.credential);
                                }}
                                containerProps={{ className: 'w-full' }}
                                shape="circle"
                                size="large"
                                theme="outline"
                                logo_alignment="center"
                                onError={() => {}}
                            />
                        </div>

                        {/* Sign up link */}
                        <p className="mt-5 font-geist text-sm text-leadrs-text-soft">
                            Pas encore inscrit ?{' '}
                            <a
                                href="/auth/sign-up"
                                className="font-medium text-leadrs-yellow-focus underline-offset-2 hover:underline"
                            >
                                Créer un compte
                            </a>
                        </p>
                    </div>
                </div>
            }
        />
    );
}

export default SignInDefault;
